import {
    GET_VENDOR_PO_DETAILS, POST_REQUEST_INSPECTION, GET_SUPPLIER_POS_WITH_STAGES,
    GET_PO_SEARCH_BY_VENDOR, GET_ALL_SUPPLIERS, GET_ALL_PO_ACCEPTANCE_DETAIL_FOR_SUPPLIER,
    GET_ALL_PO_UPLOADED_FOR_DS, GET_VENDOR_PO_DETAILS_FOR_PO_ACCEPTANCE,
} from '../type'


const initialState = {
    vendorDetails: [],
    loading: true,
    vendorPOsWithStages: [],
    requestStatus: [],
    getPOSearchByVendor: '',
    allVendors: [],
    allpodetails: [],
    allpofords: [],
    getVendorPOsForPOAcceptance: [],
}

export default function vendorReducer(state = initialState, action) {
    switch (action.type) {

        case GET_VENDOR_PO_DETAILS:
            return {
                ...state,
                vendorDetails: action.payload,
                loading: false

            }
        case POST_REQUEST_INSPECTION:
            return {
                ...state,
                loading: false,
                requestStatus: action.payload

            }
        case GET_SUPPLIER_POS_WITH_STAGES:
            return {
                ...state,
                vendorPOsWithStages: action.payload,
                loading: false

            }

        case GET_PO_SEARCH_BY_VENDOR:
            return {
                ...state,
                getPOSearchByVendor: action.payload,
                loading: false

            }

        case GET_ALL_SUPPLIERS:
            return {
                ...state,
                allVendors: action.payload,
                loading: false
            }
        case GET_ALL_PO_ACCEPTANCE_DETAIL_FOR_SUPPLIER:
            return {
                ...state,
                allpodetails: action.payload,
                loading: false

            }

        case GET_ALL_PO_UPLOADED_FOR_DS:
            return {
                ...state,
                allpofords: action.payload,
                loading: false

            }

        case GET_VENDOR_PO_DETAILS_FOR_PO_ACCEPTANCE:
            return {
                ...state,
                getVendorPOsForPOAcceptance: action.payload,
                loading: false

            }


        default: return state
    }

}